<template>
  <div class="mob-fab">
    <button 
      class="mob-fab__button"
      @click="handleClick"
      :aria-label="ariaLabel"
    >
      <svg class="icon ic-plus" width="14" height="14">
        <use xlink:href="@/assets/sprites/sprite.svg#ic-plus"></use>
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { trans } from '@/common/language/translations';

// Props
const props = defineProps<{
  onClick: () => void;
  ariaLabel?: string;
}>();

// Computed
const ariaLabel = computed(() => {
  return props.ariaLabel || trans('Create');
});

// Methods
function handleClick() {
  props.onClick();
}
</script>

<style scoped lang="scss">
.mob-fab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #3f8cff;
  box-shadow: 0 6px 12px 0 rgba(63, 140, 255, 0.26);
  position: fixed !important;
  inset-inline-end: 5rem;
  padding: 2rem;
  bottom: 100px; // Fixed position above bottom navigation (68px nav + 32px spacing)
  z-index: 9999;
  cursor: pointer;
  border: none;
  pointer-events: auto;
  // Ensure the FAB is not affected by any parent transforms or scroll effects
  transform: none !important;
  visibility: visible !important;
  opacity: 1 !important;
  overflow: visible !important;
  // Force hardware acceleration for smooth rendering
  will-change: transform;
  backface-visibility: hidden;
  // Ensure it's not affected by parent overflow or clipping
  contain: layout style paint;
  
  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
    margin: 0;
    
    .icon {
      fill: #fff;
      width: 2.5rem;
      height: 2.5rem;
    }
  }
  
  &:active {
    opacity: 0.9;
    box-shadow: 0 4px 8px 0 rgba(63, 140, 255, 0.2);
  }
}

// RTL support
[dir="rtl"] .mob-fab {
  inset-inline-end: auto;
  inset-inline-start: 5rem;
}
</style>
